import { defineComponent as _defineComponent } from 'vue'
import { useTHGUsersStore } from '@/storenew/thg/users';
    import { storeToRefs } from 'pinia';
    import { THGUserType } from '@/enums/thg/THGUserType';
    import { useTHGGlobalStore } from '@/storenew/thg/global';
    import { Country } from '@/enums/Country';
    import { THGCarStatus } from '@/enums/thg/THGCarStatus';
    import { getCarStatusText } from '@/utils/thg';
    import { onMounted, ref } from 'vue';
    import { watchIgnorable } from '@vueuse/core';
    import { THGCreateSource } from '@/enums/thg/THGCreateSource';
    import { THGUserCarYearStatusPayoffModelCombination } from '@/interfaces/thg/THGUserFilterParam';
    import { THGCarPayoffModel } from '@/enums/thg/THGCarPayoffModel';
    import THGTagInput from '@/components/thg/THGTagInput.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGUserFilters',
  setup(__props) {

    const store = useTHGUsersStore();
    const { filterParam } = storeToRefs(store);

    const { currentCountry } = useTHGGlobalStore();

    const yearStatusPayoffmodelCombiYear = ref<number>();
    const yearStatusPayoffmodelCombiStatus = ref<THGCarStatus>();
    const yearStatusPayoffmodelCombiPayoffmodel = ref<THGCarPayoffModel>();

    const { ignoreUpdates } = watchIgnorable(
        [
            yearStatusPayoffmodelCombiYear,
            yearStatusPayoffmodelCombiStatus,
            yearStatusPayoffmodelCombiPayoffmodel,
        ],
        () => {
            if (
                yearStatusPayoffmodelCombiYear.value &&
                yearStatusPayoffmodelCombiStatus.value &&
                yearStatusPayoffmodelCombiPayoffmodel.value
            ) {
                filterParam.value.car_year_status_payoffmodel = {
                    year: yearStatusPayoffmodelCombiYear.value,
                    status: yearStatusPayoffmodelCombiStatus.value,
                    payoff_model: yearStatusPayoffmodelCombiPayoffmodel.value,
                };
            } else {
                filterParam.value.car_year_status_payoffmodel = undefined;
            }
        },
    );

    const donationRatios = [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1];

    const clearMailAddress = () => (filterParam.value.email = '');
    const clearName = () => (filterParam.value.name = '');
    const clearPhoneNumber = () => (filterParam.value.phone_number = '');
    const clearVatNumber = () => (filterParam.value.vat_number = '');
    const clearZipCode = () => (filterParam.value.zip_code = '');
    const clearCity = () => (filterParam.value.city = '');
    const clearStreet = () => (filterParam.value.street = '');
    const clearStartCreateDate = () => (filterParam.value.start_create_date = undefined);
    const clearEndCreateDate = () => (filterParam.value.end_create_date = undefined);

    onMounted(() => {
        ignoreUpdates(() => {
            if (filterParam.value.car_year_status_payoffmodel) {
                yearStatusPayoffmodelCombiYear.value = (
                    filterParam.value
                        .car_year_status_payoffmodel as THGUserCarYearStatusPayoffModelCombination
                ).year;
                yearStatusPayoffmodelCombiStatus.value = (
                    filterParam.value
                        .car_year_status_payoffmodel as THGUserCarYearStatusPayoffModelCombination
                ).status;
                yearStatusPayoffmodelCombiPayoffmodel.value = (
                    filterParam.value
                        .car_year_status_payoffmodel as THGUserCarYearStatusPayoffModelCombination
                ).payoff_model;
            }
        });
    });

return { __sfc: true,store, filterParam, currentCountry, yearStatusPayoffmodelCombiYear, yearStatusPayoffmodelCombiStatus, yearStatusPayoffmodelCombiPayoffmodel, ignoreUpdates, donationRatios, clearMailAddress, clearName, clearPhoneNumber, clearVatNumber, clearZipCode, clearCity, clearStreet, clearStartCreateDate, clearEndCreateDate, THGUserType, Country, THGCarStatus, getCarStatusText, THGCreateSource, THGCarPayoffModel, THGTagInput }
}

})